export default defineNuxtRouteMiddleware(async (to) => {
  const isLoggedIn = !!useCookie('idToken').value;

  if (!isLoggedIn && !to.meta.availableForGuests) {
    return navigateTo({ name: ERouteName.LOGGED_OUT });
  }

  if (isLoggedIn && to.name === ERouteName.LOGGED_OUT) {
    return navigateTo({ name: ERouteName.LOBBY });
  }
});
